var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletSwap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14159 2.10823L4.173 4.57897C3.94285 4.77052 3.94224 5.13023 4.17173 5.3226L7.23524 7.89059C7.54424 8.14961 8.00761 7.91901 7.9999 7.51004L7.99991 2.47132C7.99238 2.07177 7.44434 1.85625 7.14159 2.10823Z",
    fill: "#36382E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8584 21.8918L19.827 19.421C20.0571 19.2295 20.0578 18.8698 19.8283 18.6774L16.7648 16.1094C16.4558 15.8504 15.9924 16.081 16.0001 16.49L16.0001 21.5287C16.0076 21.9282 16.5557 22.1437 16.8584 21.8918Z",
    fill: "#36382E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L16 5C16 5 19 5 19 8.5C19 12 16 12 16 12L8 12C8 12 5 12 5 15.5C5 19 8 19 8 19L16 19",
    stroke: "#36382E",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletSwap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_swap.85e0d14930f2abcad8dcc3c0daf70b70.svg";